<template>
    <b-modal
      id='team-calendar-modal'
      :title="trans('calendar')"
      ok-only
      size="lg"
      :ok-title="trans('close')"
    >
    <template #modal-title>
      <h5 class="mb-0">{{ team ? team.name : '' }}</h5>
    </template>
      <b-form-group :label="trans('i_calendar')">
        <b-input-group>
          <b-form-input :value="calUrl" readonly />
          <b-input-group-append>
            <b-button variant="primary" v-clipboard:copy="calUrl" :title="trans('copy')" v-b-tooltip.hover>
              <i class="fa fa-fw fa-copy"></i>
            </b-button>
          </b-input-group-append>
        </b-input-group>
        <b-form-text>{{ trans('i_calendar_team_about') }}</b-form-text>
      </b-form-group>
    </b-modal>
</template>
  
<script>
    export default {
      props: {
        organization: Object,
        team: Object, // Can be null
        page: Object, // Can be null
        block: Object, // Can be null
      },
      data() {
        return {
          trans: trans,
          busy: false,
          error: null,
        }
      },
      computed: {
        calUrl() {
          if (!this.team) {
            return ''
          }
          let slug = (this.page.slug || '').replace('/', '') || 'undefined'
          let url = `/org/${this.organization.id}/page/${this.page.upid}/${slug}/teams/${this.block.id}/schedule/${this.team.id}/calendar`
          return (_.isDev ?
          'http://activitymessenger.localhost' :
          'https://activitymessenger.com') +
          url
        },
      },    
      mounted() {
        window.teamCalendarModal = this
      },
    }
</script>